import { render, staticRenderFns } from "./DivUnit.vue?vue&type=template&id=5af5f511&scoped=true&"
import script from "./DivUnit.vue?vue&type=script&lang=js&"
export * from "./DivUnit.vue?vue&type=script&lang=js&"
import style0 from "./DivUnit.vue?vue&type=style&index=0&id=5af5f511&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af5f511",
  null
  
)

export default component.exports